const STYLES = {
  awaiting_intake: "bg-[#E3DAC9] text-[#5C5C57]",
  questionnaires_pending: "bg-amber-100 text-amber-900",
  ready_to_book: "bg-blue-100 text-blue-900",
  interview_scheduled: "bg-indigo-100 text-indigo-900",
  report_in_progress: "bg-purple-100 text-purple-900",
  qa_review: "bg-orange-100 text-orange-900",
  returned: "bg-red-100 text-red-900",
  delivered: "bg-[#2C5A2E]/10 text-[#2C5A2E]",
};

const LABELS = {
  awaiting_intake: "Complete intake",
  questionnaires_pending: "Questionnaires in progress",
  ready_to_book: "Ready to book interview",
  interview_scheduled: "Interview scheduled",
  report_in_progress: "Report in progress",
  qa_review: "In QA review",
  returned: "Returned for revision",
  delivered: "Report delivered",
};

export function StatusPill({ status }) {
  return (
    <span data-testid={`status-pill-${status}`} className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-bold tracking-wide ${STYLES[status] || "bg-gray-100 text-gray-700"}`}>
      {LABELS[status] || status}
    </span>
  );
}
